exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dots{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;overflow-x:auto}.dots__items{display:-ms-flexbox;display:flex}.dots__items>li{width:20px;height:20px;text-align:center;line-height:20px;border-radius:10px;background:#4b74c0;margin:0 10px;display:inline-block;color:white;position:relative;cursor:pointer;-webkit-transition:all 0.3s;-o-transition:all 0.3s;transition:all 0.3s}.dots__items>li::before{content:\"\";position:absolute;top:10px;left:-40px;width:45px;height:2px;background:#b8c8e1;z-index:-1}.dots__items>li:first-child::before{display:none}.dots__items-active ~ li{background:#b8c8e1}.dots__items-active ~ li::before{background:#b8c8e1}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/Dots/Dots.style.scss
// module id = 1647
// module chunks = 0